import React, { useEffect, useRef, useState } from "react";
import { WindowWithENV, WindowWithTrustpilot } from "~/types/global";

const Templates = {
  simple: "577258fb31f02306e4e3aaf9",
  large: "5717796816f630043868e2e8",
};

export const LargeTrustpilotWidget: React.FC<{ sku: string }> = ({ sku }) => {
  return (
    <TrustpilotWidget
      templateId={Templates.large}
      data-sku={sku}
      data-style-height="2100px"
      data-style-width="100%"
      className="relative"
    />
  );
};

export const SimpleTrustpilotWidget: React.FC<{ sku: string }> = ({ sku }) => {
  return (
    <TrustpilotWidget
      templateId={Templates.simple}
      data-sku={sku}
      className="float-left h-[25px]"
      data-style-height="24px"
      data-style-width="250px"
    />
  );
};

type Props = {
  className?: string;
  templateId: string;
};

const TrustpilotWidget: React.FC<Props> = ({
  className,
  templateId,
  ...rest
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [businessUnitId, setBusinessUnitId] = useState<string | null>(null);

  useEffect(() => {
    if (isLoaded) return;

    const trustpilotClient = (window as unknown as WindowWithTrustpilot)
      .Trustpilot;

    if (!trustpilotClient || !businessUnitId) {
      return;
    }

    trustpilotClient.loadFromElement(ref.current, true);
    setIsLoaded(true);
  }, [businessUnitId, isLoaded]);

  useEffect(() => {
    const trustpilotBusinessUnitId = (window as unknown as WindowWithENV).ENV
      .TRUSTPILOT_BUSINESS_UNIT_ID;

    setBusinessUnitId(trustpilotBusinessUnitId);
  }, []);

  if (!businessUnitId) {
    return null;
  }

  return React.createElement("div", {
    ...rest,
    ref,
    className: `trustpilot-widget${className ? " " + className : ""}`,
    "data-testid": `trustpilot-widget-${templateId}`,
    "data-businessunit-id": businessUnitId,
    "data-template-id": templateId,
    "data-locale": "en-US",
    "data-theme": "light",
  });
};

export default TrustpilotWidget;
